import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useParams, useHistory, useLocation, Link} from "react-router-dom";
import {deletePost, getOnePost} from "../actions/creative-station-actions/actions";
import { ImgItem } from "../components/MasonryBlock/ImgItem";
import backArrow from "../img/backArrow.png";
import "../sass/SinglePost.scss";
import {Spin, Tooltip, Button, Divider, Tag, Popconfirm} from "antd";
import {ArrowLeftOutlined, EditOutlined ,DeleteOutlined} from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import VideoComponent from "../components/MasonryBlock/VideoComponent";
import { Helmet } from "react-helmet";
import Head from "../components/Head";
import axiosInstance from "../config/axios-instance";
import { useCallback, useRef } from "react";
import { useQuery } from "react-query";
import ExampleProductCard from "../components/ProductCard/ExampleProductCard";
import { Spinner } from "../components/Spinner";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Drawer, message } from "antd";
import useWindowWidth from "../config/useWindowWidth";
import ProductServices from "../actions/products-actions/services";
import DenimProduct from "../components/ProductDetails/DenimProduct";
import KnitProduct from "../components/ProductDetails/KnitProduct";
import MixProduct from "../components/ProductDetails/MixProduct";
import BottomDrawer from "../components/BottomDrawer/BottomDrawer";
import ReactSelect from "react-select";
import { getCollaborators } from "../actions/order-actions/actions";
import { addProducttoFolder, createFolder, clearfolderToMoveTo } from "../actions/folders-actions/actions";
import Folder from "../components/Folder/Folder";
import PlusIcon from "../icons/PlusIcon";
import "../components/AddToCollection/AddToCollection.scss";

interface Props {}

export const SinglePost = (props: Props) => {
  const [post, setPost] = useState<any>(null);
  const { onePost, getOnePostLoading } = useSelector(
    (state: any) => state.posts
  );
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const params = useParams<any>();
  console.log(params)
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const folders = useSelector((state: any) => state.folders);
  const { collaborators } = useSelector((state: any) => state.orders);
  const width = useWindowWidth();

  const [quickViewProduct, setQuickViewProduct] = useState<any>(null);
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [showCollectionForm, setShowCollectionForm] = useState(false);
  const [folderData, setFolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season: '',
    year: ""
  });

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#00468c",
      },
    }),
  };

  const currentYear = new Date().getFullYear();
  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];

  const handleCreateNewFolder = () => {
    if (!folderData.name) {
      message.error("Please specify the collection name!");
      return;
    }
    dispatch(createFolder({ ...folderData, product_id: quickViewProduct?.id }));
    setShowCollectionForm(false);
    setFolderData({ name: "", description: "", collaborator: [], season: '', year: "" });
    message.success("Collection created successfully");
  };

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, [dispatch]);

  const openQuickView = async (product: any) => {
    setQuickViewProduct(product);
    setQuickViewVisible(true);
    try {
      const res = await ProductServices.getOneProduct(product.id);
      if (res.data) {
        setQuickViewProduct(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const [products3d, setProducts3d] = useState<any[]>([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetch3DProducts = async (page: number) => {
    if (!onePost || !onePost.id) {
      return;
    }
    setProductsLoading(true);
    let token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get(
        `/products/service?page=${page}&limit=30&post_id=${onePost.id}&fabric_types=denim,knit`,
       {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const { data, current_page, last_page } = response.data;
      if (data && data.length > 0) {
        setProducts3d((prev) => {
          const existingIds = new Set(prev.map((p) => p.id));
          const newProducts = data.filter((p: any) => !existingIds.has(p.id));
          return [...prev, ...newProducts];
        });
        setHasMore(current_page < last_page);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching 3D products", error);
    } finally {
      setProductsLoading(false);
    }
  };

  useEffect(() => {
    if (onePost && onePost.id) {
      setProducts3d([]);
      setCurrentPage(1);
      fetch3DProducts(1);
    }
  }, [onePost?.id]);

  useEffect(() => {
    if (currentPage > 1) {
      fetch3DProducts(currentPage);
    }
  }, [currentPage]);

  const observer = useRef<IntersectionObserver | null>(null);
  const lastProductElementRef = useCallback(
    (node) => {
      if (productsLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [productsLoading, hasMore]
  );

  const { data: companies } = useQuery("companies", async () => {
    let token = localStorage.getItem("token");
    const res = await axiosInstance.get(`/admin/companies`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const { data: clients } = useQuery("clients", async () => {
    let token = localStorage.getItem("token");
    const res = await axiosInstance.get(`/clients/for_you`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });
  useEffect(() => {
    dispatch(getOnePost(params.post_id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (onePost) {
      setPost(onePost);
    }
  }, [onePost]);

  function showMarkup(data: string) {
    return { __html: onePost[data] };
  }
    useEffect(() => {
        const trackVisit = async () => {
            const token = localStorage.getItem("token");
            if (!token || !params.post_id) return;

            try {
                await axiosInstance({
                    method: "post",
                    url: `/posts/track-visit`,
                    data: {
                        post_id: parseInt(params.post_id, 10)
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            } catch (error) {
                // If this still gives 500, it might be a server-side route issue or invalid post_id
                console.error("Error tracking post visit:", error);
            }
        };

        trackVisit();
    }, [params.post_id]);
  return getOnePostLoading ? (
    <div className="loading_article">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    post &&
      (post.type === "video" ? (
          <div className="single_post creative_station">
            <Head title={onePost.name}/>
            <Helmet>
              <meta charSet="utf-8"/>
              <meta
                  name="description"
                  content={
                      (onePost?.short_description && onePost.short_description.replace(/<[^>]*>?/gm, "")) || ""
                  }
              />
              <meta
                  property="og:description"
                  content={
                      (onePost?.short_description && onePost.short_description.replace(/<[^>]*>?/gm, "")) || ""
                  }
              />
              <meta
                  property="og:image"
                  content={process.env.REACT_APP_STORAGE_URL + onePost.file}
              />
              <title>{onePost.name}</title>
            </Helmet>
           {/* <div className="container">
              <div className="row align-items-center">

                <div className={
                  "faq_go_back"
                }
                     onClick={() => history.push("/creative-station")}
                >

                  <ArrowLeftOutlined

                  ></ArrowLeftOutlined>{" "}
                  <button
                      className={"go_back_text"}

                  >
                    Go back
                  </button>
                </div>

                <div className="col-12 title_container_post">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-end back_cs">
                      {user && isAdmin && user.type === "admin" && (
                          <div>
                            <Tooltip placement="bottom" title="Delete">

                              <Popconfirm
                                  placement="top"
                                  title={
                                    "Are you sure you want to delete this post?"
                                  }
                                  onConfirm={(e: any) => {
                                    e.stopPropagation();
                                    dispatch(deletePost(onePost?.id, onePost?.category));
                                  }}
                                  okText="Yes"
                                  cancelText="No"
                              >

                                <Button
                                    type="ghost"
                                    shape="circle"
                                    size="large"
                                    className="update_product_btn"
                                    icon={<DeleteOutlined/>}

                                />
                              </Popconfirm>
                            </Tooltip>
                            <Tooltip placement="bottom" title="Update">
                              <Button
                                  type="ghost"
                                  shape="circle"
                                  size="large"
                                  className="update_product_btn"
                                  icon={<EditOutlined/>}
                                  onClick={() =>
                                      history.push(`/single-post/${onePost.id}/update`)
                                  }
                              />
                            </Tooltip>
                          </div>
                      )}
                    </div>
                    <div className="col-12 post_header">
                      <p className="post_type_title">
                        {onePost.category.toUpperCase()}
                      </p>
                      <h1 className="post_title">{onePost.name}</h1>
                      <div className="divider_post"></div>
                      <p className="post_by">
                        BY{" "}
                        {(onePost.author && onePost.author.toUpperCase()) ||
                            "DEMCO"}
                      </p>
                      <p className="post_date">
                        {new Date(onePost.created_at).toLocaleDateString()}
                      </p>
                      <p
                          dangerouslySetInnerHTML={showMarkup("short_description")}
                      ></p>
                      <Divider plain dashed style={{opacity: 0.4}}>
                        Share this article
                      </Divider>
                      <div className="d-flex align-items-center">
                        <a
                            className="pinterest_btn mr-2"
                            href={`https://www.pinterest.com/pin/create/button/?url=${
                                window.location.href
                            }&media=${
                                process.env.REACT_APP_STORAGE_URL + onePost.file
                            }&description=${(onePost?.short_description && onePost.short_description.replace(
                                /<[^>]*>?/gm,
                                ""
                            )) || ""}`}
                            data-pin-description={onePost.short_description}
                            data-pin-url={window.location.href}
                            data-pin-media={
                                process.env.REACT_APP_STORAGE_URL + onePost.file
                            }
                            target="_blank"
                        >
                          <i className="fab fa-pinterest"></i> Pinterest
                        </a>
                        <a
                            className="linkedin_btn"
                            target="_blank"
                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}&title=${onePost.name}&source=${window.location.host}`}
                        >
                          <i className="fab fa-linkedin"></i> LinkedIn
                        </a>
                      </div>

                    </div>
                    <div
                        className="col-12 d-flex justify-content-center"
                        style={{maxHeight: 500, position: "relative"}}
                    >
                      <div style={{position: "relative", width: "50%"}}>
                        <VideoComponent post={post}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}

            <div style={{padding: "25px"}}>
              <div className="col-12 d-flex flex-column align-self-start mb-4">
                <div className="row my-3 mb-3">
                  <div className="col-12 d-flex align-items-center justify-content-between back_cs">
                    <div className={"faq_go_back"} onClick={() => history.push("/service-3d")}>
                      <ArrowLeftOutlined />
                      <button className={"go_back_text"}>Go back</button>
                    </div>
                    {user && isAdmin && user.type === "admin" && (
                      <div>
                        <Tooltip placement="bottom" title="Delete">
                          <Popconfirm
                            placement="top"
                            title={"Are you sure you want to delete this post?"}
                            onConfirm={(e: any) => {
                              e.stopPropagation();
                              dispatch(deletePost(onePost?.id, onePost?.category));
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              type="ghost"
                              shape="circle"
                              size="large"
                              className="update_product_btn"
                              icon={<DeleteOutlined />}
                            />
                          </Popconfirm>
                        </Tooltip>
                        <Tooltip placement="bottom" title="Update">
                          <Button
                            type="ghost"
                            shape="circle"
                            size="large"
                            className="update_product_btn"
                            icon={<EditOutlined />}
                            onClick={() => history.push(`/single-post/${onePost.id}/update`)}
                          />
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row title_container_post">
                  <div className="col-12 post_header">
{/*                     <p className="post_type_title">{onePost.category.toUpperCase()}</p>
 */}                    <h1 className="post_title">3D SERVICES</h1>
                    <div className="divider_post"></div>
                   {/*  <p className="post_by">
                      BY {(onePost.author && onePost.author.toUpperCase()) || "DEMCO"}
                    </p>
                    <p className="post_date">
                      {new Date(onePost.created_at).toLocaleDateString()}
                    </p>
                    <p dangerouslySetInnerHTML={showMarkup("short_description")}></p>
 */}
                  </div>
                </div>
              </div>

              <section>
                <div className="row">
                  <div className="col-6">
                    <div style={{ maxHeight: "1000px", overflowY: "auto", overflowX: "hidden", paddingRight: "15px" }}>
                      <div
                        className="col-12"
                        style={{ maxHeight: "none", position: "relative" }}
                      >
                        <div className="masnory_block" style={{ marginBottom: "120px" }}>
                          <header>
                            <h1 className="h1_title" style={{ whiteSpace: "nowrap" }}>
                              3D VIDEOS
                            </h1>
                            <div className="blue_line"></div>
                          </header>
                        </div>
                        <div style={{ position: "relative", width: "100%" }}>
                          <VideoComponent post={post} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div style={{ maxHeight: "1000px", overflowY: "auto", overflowX: "hidden", paddingLeft: "15px" }}>
                      <div className="masnory_block" style={{ marginBottom: "120px" }}>
                        <header>
                          <h1 className="h1_title" style={{ whiteSpace: "nowrap" }}>
                            3D PRODUCTS
                          </h1>
                          <div className="blue_line"></div>
                        </header>
                      </div>
                      <div className="mt-5">
                        {products3d.length === 0 && productsLoading ? (
                          <Spinner />
                        ) : (
                          <DragDropContext onDragEnd={() => { }}>
                            <Droppable droppableId="products-3d-droppable" direction="vertical">
                              {(provided) => (
                                <div
                                  className="row"
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {products3d?.map((product: any, index: number) => {
                                    if (products3d.length === index + 1) {
                                      return (
                                        <div
                                          className="col-12 col-md-6 mb-4"
                                          key={product.id}
                                          ref={lastProductElementRef}
                                        >
                                          <ExampleProductCard
                                            index={index}
                                            productPage={true}
                                            product={product}
                                            company={companies}
                                            clients={clients}
                                            onClick={openQuickView}
                                            item={{
                                              main: product.images[0] ? product.images[0].path : "",
                                              onHover: product.images[1] ? product.images[1].path : "",
                                            }}
                                          />
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="col-12 col-md-6 mb-4" key={product.id}>
                                          <ExampleProductCard
                                            index={index}
                                            productPage={true}
                                            product={product}
                                            company={companies}
                                            clients={clients}
                                            onClick={openQuickView}
                                            item={{
                                              main: product.images[0] ? product.images[0].path : "",
                                              onHover: product.images[1] ? product.images[1].path : "",
                                            }}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                  {productsLoading && <Spinner />}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <Drawer
              title="Product Details"
              placement={width > 768 ? "right" : "bottom"}
              width={width > 768 ? 720 : "100%"}
              height={width > 768 ? "100%" : "85vh"}
              onClose={() => setQuickViewVisible(false)}
              visible={quickViewVisible}
              bodyStyle={{ padding: 0 }}
            >
              {quickViewProduct && (
                <div
                  className="product_details_contanier"
                  style={{ height: "100%", display: "flex", flexDirection: "column" }}
                >
                  <div
                    className="product_details_infos_scroll"
                    style={{ border: "none", flex: 1, overflowY: "auto" }}
                  >
                    <div
                      className="product_details_infos"
                      style={{ height: "auto", overflow: "visible" }}
                    >
                      <div className="component_details">
                        {quickViewProduct.fabric_type === "denim" && (
                          <DenimProduct
                            key="denim_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => { }}
                          />
                        )}
                        {(quickViewProduct.fabric_type === "knit" ||
                          quickViewProduct.fabric_type === "home_textile") && (
                          <KnitProduct
                            key="knit_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => { }}
                          />
                        )}
                        {quickViewProduct.fabric_type === "mix" && (
                          <MixProduct
                            key="mix_main"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => { }}
                          />
                        )}

                        {!["denim", "knit", "mix"].includes(
                          quickViewProduct.fabric_type
                        ) &&
                          quickViewProduct.fabric_types && (
                            <div key="alternate_view">
                              {quickViewProduct.fabric_types.name?.toLowerCase() ===
                                "denim" && (
                                <DenimProduct
                                  key="denim_alt"
                                  oneProduct={quickViewProduct}
                                  editMode={false}
                                  setEditMode={() => { }}
                                />
                              )}
                              {quickViewProduct.fabric_types.name?.toLowerCase() ===
                                "knit" && (
                                <KnitProduct
                                  key="knit_alt"
                                  oneProduct={quickViewProduct}
                                  editMode={false}
                                  setEditMode={() => { }}
                                />
                              )}
                              {quickViewProduct.fabric_types.name?.toLowerCase() ===
                                "mix" && (
                                <MixProduct
                                  key="mix_alt"
                                  oneProduct={quickViewProduct}
                                  editMode={false}
                                  setEditMode={() => { }}
                                />
                              )}
                            </div>
                          )}
                      </div>

                      {folders && folders.folders && folders.folders.length > 0 && (
                        <div style={{ position: "relative", padding: "20px", background: "#fff", height: "auto", minHeight: "400px" }}>
                          {showCollectionForm ? (
                            <div className="create_collection_form_modern" style={{
                              padding: "24px",
                              borderRadius: "16px",
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px"
                            }}>
                              <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>

                              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                                <input
                                  type="text"
                                  placeholder="e.g. Summer 2027"
                                  value={folderData.name}
                                  onChange={(e) => setFolderData({ ...folderData, name: e.target.value })}
                                  style={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "8px",
                                    width: "100%",
                                    outline: "none",
                                    fontSize: "14px",
                                    padding: "10px 14px",
                                    background: "white",
                                    transition: "border-color 0.2s"
                                  }}
                                />
                              </div>

                              <div style={{ display: "flex", gap: "16px" }}>
                                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                  <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                                  <ReactSelect
                                    placeholder="Select Season"
                                    options={options_season}
                                    value={options_season.find(o => o.value === folderData.season)}
                                    onChange={(val: any) => setFolderData({ ...folderData, season: val.value })}
                                    styles={customStylesCreateModern}
                                  />
                                </div>
                                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                                  <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                                  <ReactSelect
                                    placeholder="Select Year"
                                    options={options_year}
                                    value={options_year.find(o => o.value === folderData.year)}
                                    onChange={(val: any) => setFolderData({ ...folderData, year: val.value })}
                                    styles={customStylesCreateModern}
                                  />
                                </div>
                              </div>

                              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                                <ReactSelect
                                  isMulti
                                  placeholder="Search names..."
                                  options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                                  onChange={(val: any) => setFolderData({ ...folderData, collaborator: val.map((v: any) => v.value) })}
                                  styles={customStylesCreateModern}
                                />
                              </div>

                              <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "8px" }}>
                                <button
                                  className="btn_modern_cancel"
                                  onClick={() => setShowCollectionForm(false)}
                                  style={{
                                    padding: "12px",
                                    borderRadius: "10px",
                                    border: "1px solid #e1e8f0",
                                    background: "white",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn_modern_confirm"
                                  onClick={handleCreateNewFolder}
                                  style={{
                                    padding: "12px",
                                    borderRadius: "10px",
                                    border: "none",
                                    background: "#00468c",
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                  }}
                                >
                                  Create
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                                <span style={{ fontSize: "14px", fontWeight: 600, color: "#64748b" }}>Choose a collection</span>
                                <Tooltip title="Create New Collection">
                                  <button
                                    onClick={() => setShowCollectionForm(true)}
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      border: "1px solid #e1e8f0",
                                      background: "white",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      color: "#00468c",
                                      transition: "all 0.2s"
                                    }}
                                  >
                                    <PlusIcon />
                                  </button>
                                </Tooltip>
                              </div>

                              <div className="list_folders" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: "8px", maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                                {folders.folders &&
                                  folders.folders
                                    .filter((el: any) => el.client_id == user.id)
                                    .map((folder: any) => (
                                      <Folder
                                        clickable={true}
                                        selectOneFolder={true}
                                        addToCollection={true}
                                        folder={folder}
                                        key={folder.id}
                                      />
                                    ))}
                              </div>

                              <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "20px" }}>

                                <button
                                  className="btn_modern_confirm"
                                  onClick={() => {
                                    if (folders.folderIdToMoveTo) {
                                      dispatch(addProducttoFolder(folders.folderIdToMoveTo, quickViewProduct?.id));
                                      dispatch(clearfolderToMoveTo());
                                    } else {
                                      message.error("Please select a collection first");
                                    }
                                  }}
                                  style={{
                                    padding: "8px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#00468c",
                                    color: "white",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    cursor: "pointer"
                                  }}
                                >
                                  Confirm
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ padding: "10px 30px 20px" }}>
                    <Link
                      to={`/product/details/${quickViewProduct.fabric_type || 'all'}/${quickViewProduct.gender_id || 'all'}/${quickViewProduct.category_id || 'all'}/${quickViewProduct.name}/${quickViewProduct.id}`}
                      className="ant-btn ant-btn-primary ant-btn-block"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "50px",
                        fontSize: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#000",
                        borderColor: "#000",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                      }}
                    >
                      VIEW FULL DETAILS
                    </Link>
                  </div>
                </div>
              )}
            </Drawer>
            <BottomDrawer mode="add_to_collection" />
          </div>
      ) : (
        
        <>
          <div className="single_post">
            <div id="notfound">
              <div className="notfound">
                <div className="notfound-404">
                  <h1>Oops!</h1>
                  <h2>404 - The Post can't be found</h2>
                </div>
                <Link to="/">Go TO Homepage</Link>
              </div>
            </div>
          </div>
        </>
                  
                  

              ))
  );
};
